// Round-10 / H1 phase 2 — refresh token no longer lives in localStorage.
// The browser's httpOnly cookie (set by /auth/login since phase 1) carries
// it, scoped to /api/v1/auth/refresh with SameSite=Strict. Access token
// stays in localStorage for now (15-min TTL, low-value); a future phase
// can move it in-memory if we want to harden further.
//
// REFRESH_KEY removed. Existing localStorage entries from pre-phase-2
// builds will sit around unused until clearAuth() runs on next logout.
const TOKEN_KEY = 'auth_token';
const USER_ID_KEY = 'auth_user_id';
const LEGACY_REFRESH_KEY = 'auth_refresh'; // cleanup-only

function getItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function setItem(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* quota or disabled storage */
  }
}

function removeItem(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export const setAuth = async (token: string, userId: string): Promise<void> => {
  setItem(TOKEN_KEY, token);
  setItem(USER_ID_KEY, userId);
  // Best-effort cleanup: if a stale refresh token from a pre-phase-2
  // build is sitting in localStorage, drop it on next login.
  removeItem(LEGACY_REFRESH_KEY);
};

export const setAccessToken = async (token: string): Promise<void> => {
  setItem(TOKEN_KEY, token);
};

export const getToken = async (): Promise<string | null> => getItem(TOKEN_KEY);
export const getUserId = async (): Promise<string | null> => getItem(USER_ID_KEY);

export const clearAuth = async (): Promise<void> => {
  removeItem(TOKEN_KEY);
  removeItem(USER_ID_KEY);
  removeItem(LEGACY_REFRESH_KEY);
};

export const isAuthenticated = async (): Promise<boolean> => getItem(TOKEN_KEY) !== null;
